/**
 * Generic Events in the host-ux package
 */
export enum GenericEvent {
  /** Disconnected Banner was shown */
  DisconnectedBannerShown = 'DisconnectedBannerShown',
  /** Share dialog was opened */
  ShareDialogOpened = 'ShareDialogOpened'
}

/**
 * Subcategories of the Generic Event in the host-ux package
 */
export enum GenericEventSubcategories {
  MessageBanner = 'MessageBanner'
}
